module.exports = __webpack_public_path__ + "img/logo_intersiam.19f557e4.jpg";